import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Chart } from 'chart.js';


@Injectable({
	providedIn: 'root'
})
export class TypographyService {

	constructor(
		@Inject(DOCUMENT) private document: Document,
		@Inject(PLATFORM_ID) private platformId: object
	) {}

	initialize(): void {
		if (!isPlatformBrowser(this.platformId)) return;

		const rootStyle: CSSStyleDeclaration = getComputedStyle(this.document.documentElement);
		const bodyStyle: CSSStyleDeclaration = getComputedStyle(this.document.body);
		const fontFamily: string = rootStyle.getPropertyValue('--ui-font-family').trim()
			|| bodyStyle.fontFamily;
		const fontSize: number = Number.parseFloat(bodyStyle.fontSize);

		Chart.defaults.font.family = fontFamily;
		if (Number.isFinite(fontSize)) Chart.defaults.font.size = fontSize;
	}
}
